import React from "react"

export type DocumentContentSourceFrontmatterBarProps = {
  showFrontmatterInSource: boolean
  onToggle: (next: boolean) => void
}

export function DocumentContentSourceFrontmatterBar({
  showFrontmatterInSource,
  onToggle,
}: DocumentContentSourceFrontmatterBarProps) {
  return (
    <div className="flex h-11 shrink-0 items-center gap-2 border-b border-border bg-muted/25 px-3">
      <button
        type="button"
        className={`px-2 py-1 text-xs rounded transition-colors ${
          showFrontmatterInSource
            ? "bg-primary text-primary-foreground"
            : "text-muted-foreground hover:text-foreground"
        }`}
        title="Show YAML frontmatter in Source (off = folded; line numbers match the file on disk)"
        tabIndex={-1}
        onClick={() => {
          const next = !showFrontmatterInSource
          onToggle(next)
        }}
      >
        Frontmatter
      </button>
    </div>
  )
}
